import { formatRM } from '@bazaar/shared';
import { BigButton } from './BigButton.js';

export interface BottomBarProps {
  itemCount: number;
  totalCents: number;
  onReview: () => void;
}

/** The sticky "N items - RM total - Review" bar shown above the bottom nav while the cart isn't empty. */
export function BottomBar({ itemCount, totalCents, onReview }: BottomBarProps) {
  if (itemCount === 0) return null;

  return (
    <div className="fixed bottom-[65px] lg:bottom-0 inset-x-0 z-30 bg-pink text-ink shadow-lg">
      <div className="page-container flex items-center justify-between gap-4 py-3">
        <span className="font-heading font-semibold text-base">
          {itemCount} item{itemCount === 1 ? '' : 's'} &middot; {formatRM(totalCents)}
        </span>
        <BigButton variant="primary" onClick={onReview}>
          Review
        </BigButton>
      </div>
    </div>
  );
}
